export default __webpack_public_path__ + "static/media/image-currency.32459277.jpg";